var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCollapseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 9,
    viewBox: "0 0 5 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.294291 2.15081C0.201076 2.05889 0.127058 1.94937 0.0765371 1.8286C0.0260161 1.70783 0 1.57822 0 1.44731C0 1.3164 0.0260161 1.18679 0.0765371 1.06602C0.127058 0.945254 0.201076 0.835729 0.294291 0.743812C0.483309 0.557245 0.738206 0.452637 1.00379 0.452637C1.26938 0.452637 1.52427 0.557245 1.71329 0.743812L4.67829 3.68381C4.78049 3.78514 4.8616 3.90571 4.91696 4.03856C4.97231 4.1714 5.00081 4.31389 5.00081 4.45781C5.00081 4.60173 4.97231 4.74422 4.91696 4.87707C4.8616 5.00991 4.78049 5.13048 4.67829 5.23181L1.72329 8.16181C1.53423 8.34868 1.27912 8.45348 1.01329 8.45348C0.747463 8.45348 0.492353 8.34868 0.303291 8.16181C0.210077 8.06989 0.136058 7.96037 0.085537 7.8396C0.0350159 7.71883 0.00899982 7.58922 0.00899982 7.45831C0.00899982 7.3274 0.0350159 7.19779 0.085537 7.07702C0.136058 6.95625 0.210077 6.84673 0.303291 6.75481L2.62129 4.45781L0.294291 2.15081Z",
    fill: "#495057"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseIcon);
export default __webpack_public_path__ + "static/media/collapse-icon.aa743d1bd69af92afae25f661a09e983.svg";
export { ForwardRef as ReactComponent };